var CustomerType;
(function(CustomerType) {
    CustomerType["Private"] = 'private';
    CustomerType["Company"] = 'company';
})(CustomerType || (CustomerType = {}));

export { CustomerType };
//# sourceMappingURL=types.js.map
